import React from "react";
export default function SVGDocCheck() {
  return (
    <svg id="Capa_1" height="512" viewBox="0 0 510 510" width="512">
      <g fill="#000000">
        <path
          fill="#000000"
          d="m345 30v-30h-180v30h-90v480h360v-480zm-150 0h120v30h-120zm210 450h-300v-420h60v30h180v-30h60z"
        />
        <path
          fill="#000000"
          d="m315.821 154.981-16.641-24.961-66.269 44.179-17.93-26.894-24.961 16.641 34.57 51.855z"
        />
        <path fill="#000000" opacity="0.6" d="m150 285h210.001v30h-210.001z" />
        <path fill="#000000" opacity="0.6" d="m150 345h210.001v30h-210.001z" />
        <path fill="#000000" opacity="0.6" d="m150 405h210.001v30h-210.001z" />
      </g>
    </svg>
  );
}
